import script from "./Return.vue?vue&type=script&setup=true&lang=js"
export * from "./Return.vue?vue&type=script&setup=true&lang=js"

import "./Return.vue?vue&type=style&index=0&id=26c6846e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26c6846e"]])

export default __exports__